import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const BasketballTab = (props) => {
  return (
    <SimpleShowLayout record={props.record[props.side]}>
      <TextField source="season.team.name" />
      <TextField source="id" />
      <TextField source="basketball.totalPoints" />
      <TextField source="basketball.firstQuarterPoints" />
      <TextField source="basketball.secondQuarterPoints" />
      <TextField source="basketball.thirdQuarterPoints" />
      <TextField source="basketball.fourthQuarterPoints" />
      <TextField source="basketball.overtimePoints" />
      <TextField source="basketball.overtime2Points" />
      <TextField source="basketball.overtime3Points" />
    </SimpleShowLayout>
  );
};

export default BasketballTab;
